import classNames from "classnames";
import * as React from "react";

import styles from "./ResourceView.module.css";

interface ResourceViewActionsProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Horizontal action-button row slot for `ResourceView.Root`. Hosts the filter
 * button and any future controls (column visibility, density, export).
 * Children lay out in a flex row with consistent gap and wrap onto a new
 * line on narrow viewports; consumers wrap it in their own div if they
 * need additional alignment.
 *
 * @example
 * ```tsx
 * <ResourceView.Root>
 *   <ResourceView.Actions>
 *     <ResourceView.Filters filterDefinitions={fields} />
 *   </ResourceView.Actions>
 *   <DataTable table={view.table} ... />
 * </ResourceView.Root>
 * ```
 */
export function ResourceViewActions({
  children,
  className,
}: ResourceViewActionsProps) {
  return (
    <div className={classNames(styles.actions, className)}>{children}</div>
  );
}
